// Operasyon kanalı (ops:<firma>): uyarı, araç ve müdahale olaylarında ilgili sorgular tazelenir (en sık 2 sn'de bir).
import { useEffect, useRef } from 'react';
import { createRealtime, type RealtimeEvent } from '@serota/api-client';
import { API_URL } from './config';
import { api, getCompanyId, tokenStore } from './api';

export const realtime = createRealtime({
  apiUrl: API_URL,
  tokens: tokenStore,
  refresh: () => api.context(),
  getCompanyId,
});

export function useRealtime(channels: string[], onEvent: (e: RealtimeEvent) => void, minGapMs = 2000): void {
  const handler = useRef(onEvent);
  handler.current = onEvent;
  const key = channels.join(',');
  useEffect(() => {
    const list = key ? key.split(',') : [];
    list.forEach((c) => realtime.subscribe(c));
    let timer: ReturnType<typeof setTimeout> | null = null;
    let last: RealtimeEvent | null = null;
    let lastRun = 0;
    const off = realtime.on((e) => {
      last = e;
      if (timer) return;
      timer = setTimeout(
        () => {
          timer = null;
          lastRun = Date.now();
          if (last) handler.current(last);
        },
        Math.max(0, lastRun + minGapMs - Date.now()),
      );
    });
    return () => {
      off();
      if (timer) clearTimeout(timer);
      list.forEach((c) => realtime.unsubscribe(c));
    };
  }, [key, minGapMs]);
}
